module.exports = __webpack_public_path__ + "static/media/2.5283fbe0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/baliza/2.jpg
// module id = 508
// module chunks = 0